import React from "react";

import "./styles.css";

const Button = {
  Main: ({
    onPress,
    text,
    rightIcon = null,
    leftIcon = null,
    className = "",
  }) => {
    const LeftIconComponent = leftIcon ? (
      <div className="button-icon">{leftIcon}</div>
    ) : (
      <></>
    );

    const RightIconComponent = rightIcon ? (
      <div className="button-icon">{rightIcon}</div>
    ) : (
      <></>
    );

    return (
      <div className={"button-main-container " + className}>
        <button
          onClick={onPress}
          className={
            "button button-main primary " +
            (leftIcon && " pr-2 ") +
            (rightIcon && " pl-2 ")
          }
        >
          {LeftIconComponent}
          <span>{text}</span>
          {RightIconComponent}
        </button>
      </div>
    );
  },

  PrimarySmall: ({ onPress, text, rightIcon = null, leftIcon = null }) => {
    const LeftIconComponent = leftIcon ? (
      <div className="button-icon">{leftIcon}</div>
    ) : (
      <></>
    );

    const RightIconComponent = rightIcon ? (
      <div className="button-icon">{rightIcon}</div>
    ) : (
      <></>
    );

    return (
      <button
        onClick={onPress}
        className={
          "button button-small primary " +
          (leftIcon && " pr-2 ") +
          (rightIcon && " pl-2 ")
        }
      >
        {LeftIconComponent}
        <span>{text}</span>
        {RightIconComponent}
      </button>
    );
  },
};

export default Button;
